module.exports = __webpack_public_path__ + "img/img_acceso.d860a46e.png";